<app-dialog-header *ngIf="this.dataDialog.isDialog" label="Alarmes" i18n-label></app-dialog-header>

<app-toolbar>
  <!--<app-tool-button text="Editar" i18n-text (click)="editAgent();" color="has-color-orange" icon="fa-edit" [disabled]="selectCheckedItems() == 1 ? false : true"></app-tool-button>-->
  <app-tool-button text="Llista" i18n-text (click)="this.goLlista()" color="has-color-yellow" icon="fa-th-list"></app-tool-button>
  <app-tool-button text="Actualizar" i18n-text (click)="refresh();" color="has-color-blue" icon="fa-sync"></app-tool-button>
  <app-tool-button text="Filtre" i18n-text (click)="onFilterClicked();" color="has-color-orange" icon="fa-filter"></app-tool-button>
 
<!--
   <app-tool-button-permissions [permission]="this.auth.Pages.Agents"></app-tool-button-permissions>
  -->
</app-toolbar>


<app-alarmes-table [selectButton]="this.dataDialog.isDialog && !this.dataDialog.isReadOnly" [updatedFilterData]="filterData" (notify)="onRowSelected($event)" [isHistoric]="true"></app-alarmes-table>

